export default "__VITE_ASSET__ChUOs6vm__"